<div class="p-3">
  <h2>Overall rating</h2>
  <p class="text-xs">Check overall satisfaction, rating and metrics</p>
</div>
<div class="container-iframe">
  <iframe [src]="url" class="responsive-iframe"></iframe>
</div>
